import { render, staticRenderFns } from "./remove-icon.vue?vue&type=template&id=83293eb6&"
import script from "./remove-icon.vue?vue&type=script&lang=js&"
export * from "./remove-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports